module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bounceDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("APP首页弹框管理 > 查看详情\n        "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹框名称：")]), _vm._v(_vm._s(_vm.bounce.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹框类型：")]), _vm._v(_vm._s(_vm.bounce.bounceType) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title imgSpan"
  }, [_vm._v("弹框图片：")]), _vm._v(" \n            "), (_vm.bounce.irregularImgUrl) ? _c('img', {
    attrs: {
      "src": _vm.bounce.irregularImgUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "src": _vm.bounce.imgUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹框主标题：")]), _vm._v(_vm._s(_vm.bounce.mainTitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹框副标题：")]), _vm._v(_vm._s(_vm.bounce.subTitle) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("按钮文案：")]), _vm._v(_vm._s(_vm.bounce.btnText) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹出周期：")]), _vm._v(_vm._s(_vm.bounce.showStatus) + "\n        ")]), _vm._v(" "), (_vm.bounce.adExposingCodes) ? _c('div', {
    staticStyle: {
      "height": "135px",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("广告曝光代码：")]), _vm._v(" "), _c('span', {
    staticClass: "contain"
  }, [_vm._v(_vm._s(_vm.bounce.adExposingCodes))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("起止日期：")]), _vm._v(_vm._s(_vm.bounce.startTime) + " 至 " + _vm._s(_vm.bounce.endTime) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("点击事件：")]), _vm._v(_vm._s(_vm.bounce.clickType) + _vm._s(_vm.bounce.targetUrl) + "\n        ")]), _vm._v(" "), (_vm.bounce.showPopupPrompt) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("是否弹窗提示：")]), _vm._v(_vm._s(_vm.bounce.isPopup === 1 ? '是' : '否') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.bounce.showPopupPrompt && _vm.bounce.isPopup === 1) ? _c('div', {
    staticClass: "panel"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("弹窗内容：")]), _vm._v(_vm._s(_vm.bounce.popupContent) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.bounce
    }
  }, [_c('select-school', {
    attrs: {
      "schObj": _vm.bounce.schObj,
      "canUse": _vm.canUse
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ee7a885!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/bounce/bounceDetail.vue
// module id = 997
// module chunks = 0